export default "__VITE_ASSET__B9pix4yX__"